import { Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { Modal } from '@abyss/web/ui/Modal';
import { isEmpty } from 'lodash';
import find from 'lodash/find';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../common/Utils/getFeatureFlag';
import {
  useEducationalContentStatus,
  useSaveEducationalContentStatus,
} from '../../hooks/useEducationalContent';
import { useLagoon } from '../../hooks/useLagoon';
import { StoreKeys } from '../../hooks/useStore/state';
import { useStore } from '../../hooks/useStore/useStore';
import {
  guestStartModalInfoStyles,
  guestStartModalStyles,
} from './GuestFirstTimeUserModal.style';

export const GuestFirstTimeUserModal = () => {
  const [isOpen, setIsOpen] = useState(true);
  const featureFlags = useLagoon('feature-flags')();
  const data = useLagoon('ui-messaging')();
  const { t } = useTranslation();

  const guestStartModalTitle = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GUEST_START_MODAL_TITLE,
  });
  const guestStartModalDescription = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.GUEST_START_MODAL_DESCRIPTION,
  });

  const setEducationalContentStore = useStore(
    StoreKeys.SET_EDUCATIONAL_CONTENT_STATUS
  );

  const educationalContentStore = useStore(
    StoreKeys.EDUCATIONAL_CONTENT_STATUS
  );

  const [educationalContent, getEducationalContentStatus] =
    useEducationalContentStatus({
      onCompleted: (educationalContent) => {
        if (educationalContent?.data?.educationalContentStatus) {
          setEducationalContentStore(
            educationalContent.data.educationalContentStatus
          );
        }
      },
    });

  const [, setEducationalContentStatus] = useSaveEducationalContentStatus({
    onCompleted: (saveEducationalContent) => {
      if (saveEducationalContent?.data?.saveEducationalContentStatus) {
        setEducationalContentStore(
          saveEducationalContent.data.saveEducationalContentStatus
        );
      }
    },
  });

  useEffect(() => {
    if (isEmpty(educationalContentStore)) {
      getEducationalContentStatus({
        variables: {},
      });
    }
  }, []);

  const educationalContentStatus =
    educationalContent?.data?.educationalContentStatus ??
    educationalContentStore;
  const hasViewedGuestStartModal =
    educationalContentStatus?.hasViewedGuestStartModal;

  useEffect(() => {
    if (hasViewedGuestStartModal === false) {
      setEducationalContentStatus({
        variables: {
          ...educationalContentStore,
          hasViewedContent: educationalContentStore?.hasViewedContent ?? true,
          hasViewedGuestStartModal: true,
        },
      });
    }
  }, [hasViewedGuestStartModal]);

  const guestStartModalEnabled = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.GUEST_START_MODAL_ENABLED
  );

  if (guestStartModalEnabled && hasViewedGuestStartModal === false) {
    return (
      <React.Fragment>
        <Modal
          css={guestStartModalStyles}
          data-testid="guest-start-modal"
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
          title={guestStartModalTitle?.message}
        >
          <Modal.Section
            css={guestStartModalInfoStyles}
            data-testid="guest-start-modal-info"
          >
            {guestStartModalDescription?.message}
          </Modal.Section>
          <Modal.Section>
            <Layout.Group alignLayout="left">
              <Button
                data-testid="guest-get-started-button"
                onClick={() => setIsOpen(false)}
              >
                {t('GUEST_FIRST_TIME_USER_MODAL.GET_STARTED_BUTTON')}
              </Button>
            </Layout.Group>
          </Modal.Section>
        </Modal>
      </React.Fragment>
    );
  }
  return null;
};
